import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { AccessibilityStore, DataStore } from '../stores';
import { ChartStore } from '../stores';
import ChartPeriodSelectorButton from './ChartPeriodSelectorButton';
import { Theme } from '../models/Theme';

const ChartPeriodSelectorWrapper = styled<any, any>(
    'div',
    'chartPeriodSelectorWrapper',
    'chartPeriodSelector'
)`
    ${propStyles};
`;

ChartPeriodSelectorWrapper.defaultProps = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: ['center', 'flex-start'],
    marginY: 'sm',
};
interface ChartPeriodSelectorProps {
    theme?: Theme;
    accessibilityStore?: AccessibilityStore;
    dataStore?: DataStore;
    chartStore?: ChartStore;
}
@observer
export class ChartPeriodSelector extends Component<ChartPeriodSelectorProps> {
    constructor(props: ChartPeriodSelectorProps) {
        super(props);
    }

    render() {
        const { theme, chartStore } = this.props;

        if (!chartStore) {
            return null;
        }
        const { periodSelector } = chartStore;
        const { noDataForPeriodUi, options } = periodSelector;
        return (
            <ChartPeriodSelectorWrapper {...theme.ChartPeriodSelectorWrapper}>
                {options.map(option => {
                    return (
                        <ChartPeriodSelectorButton
                            key={option.label}
                            chartStore={chartStore}
                            option={option}
                            noDataForPeriodUi={noDataForPeriodUi}
                        />
                    );
                })}
            </ChartPeriodSelectorWrapper>
        );
    }
}

export default withTheme(ChartPeriodSelector);



// WEBPACK FOOTER //
// ./src/Components/ChartPeriodSelector.tsx